import React, { useState, useEffect } from "react";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import MyChartContainer from "./MyChartContainer";
import { withRouter } from 'react-router';
import { useHistory } from "react-router-dom";
import { MyChartHeading } from "../ecosystem/mybswh";

const MessagesSend = () => {
    const [showQTXSurvey, setShowQTXSurvey] = useState(false);
    const [childFrameData, setChildFrameData] = useState({});
    const events = [{ elements: "button._actionable.Topic.selectionOption:not(.titleOnly)", eventName: "click", message: "buttonChoice", containerId: "appPopupRoot", dataTile:"MessagesSend" },{ elements: "h2.sectionTitle", eventName: "click", message: "heading", containerId: "appPopupRoot", dataTile:"MessagesSend"  },];
    const history = useHistory();
    useEffect(() => {
        logUI("MBHWeb.UI.MessagesSend.ComponentDidMount", new Date(), Tools.getURLPath());
    }, []);

    useEffect(() => {
        console.info(`MessagesSend addQTXDiv`, childFrameData);
        if (window.serverData.data.enableQualtricsSurveySendMessage && childFrameData.event === "bswMatchedMutation" && childFrameData.data.type === "childList" && childFrameData.data.target === "div.Toast") {
            console.info(`MessagesSend addQTXDiv got the expected tag added`, childFrameData);
            setShowQTXSurvey(true);
        }
    }, [childFrameData, showQTXSurvey]);

    const { proxyName } = Tools.getProxyName();
    const heading = (<MyChartHeading heading="Send a Message" proxyName={proxyName} />);
    return <MyChartContainer
        id="MessagesSend"
        showQTXSurvey={showQTXSurvey}
        bswMatch={["div.Toast"]}
        observe="#appPopupRoot"
        events={events }
        onObserved={(messageEvent) => { console.info(`MessasgesSend onObserved`); setChildFrameData(messageEvent); }}
        onMessage={(event) => { doEventMatch(event, history) }} 
        src={`${window.serverData.data.myChartBaseUrl}app/communication-center/ask-question`}
        title="Send a Message"
        heading={heading} />;
};
//Allowing current behavior to stay until green lit.
const doEventMatch = (event,history) => {
    console.info('MessagesSend doEventMatch event.data, history', event.data,history);
    try {
        if(event.data?.evt?.dataTile === "MessagesSend") {
            const evtMessage = event.data?.evt?.message || '';
            switch (evtMessage) {
                case 'buttonChoice':
                    buttonChoice(event, history);
                    break;
                case 'heading':
                    console.info(`MessagesSend doEventMatch heading`);
                    break;
                default:
                    console.info(`MessagesSend doEventMatch no matching event so ignoring`);
            }
        }
    } catch (e) {
        console.info('MessagesSend doEventMatch error,event',e,event);
    }
}

const buttonChoice = (event, history) => {
    try {
        console.info(`MessagesSend buttonChoice event`,event);

        if (event.data?.bswElement?.innerText.indexOf('Scheduling')>=0) {//mychartDataTile
            //document.getElementById('mychartDataTile').style.display = 'none';
            document.getElementById(event.data?.evt?.dataTile).remove();
            history.push('/schedulenow');
            console.info('MessagesSend buttonChoice after histoyr push');
        }
    } catch (e) {
        console.info('MessagesSend buttonChoice error,event', e, event);
    }
}

export default withRouter(MessagesSend);